import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class StoreStateService {
  private readonly key = 'lucky.draw.selected.store.id';
  private readonly subject = new BehaviorSubject<number | null>(Number(localStorage.getItem(this.key)) || null);
  readonly storeId$ = this.subject.asObservable();
  get storeId(): number | null { return this.subject.value; }
  setStoreId(id: number): void { localStorage.setItem(this.key, String(id)); this.subject.next(id); }
  clearStore(): void { localStorage.removeItem(this.key); this.subject.next(null); }
}
